<template>
  <div class="select-payment-type-buttons">
    <vs-popup :active.sync="showOtherPaymentMethods" id="otherPayTypesPage">
      <div class="other-pay-popup-inner">
        <div class="other-pay-popup-header">
          <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
            <vs-button color="transparent" class="payment-label bg-primary2 text-white w-full other-pay-title-btn" icon-pack="feather"
              icon="icon-credit-card">
              Ödeme Seçenekleri
            </vs-button>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="info-row other-pay-info-row" v-if="activePersonal">
            <vs-col vs-type="flex" class="w-auto">
              <p class="text-primary bold mr-3">
                Personal Adı :
              </p>
              <p class="text-primary">
                {{activePersonal.name}}
              </p>
            </vs-col>
            <vs-col vs-type="flex" class="w-auto ml-auto">
              <p class="text-primary">{{currentDate}}</p>
            </vs-col>
            <vs-col vs-type="flex" class="w-auto ml-3">
              <p class="text-primary">{{currentTime}}</p>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="other-pay-hero-row">
            <vs-col vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                <img class="other-pay-hero-img responsive" src="@/assets/general/payment-method.svg" alt="" />
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                <p class="text-primary other-pay-hint">Lütfen ödeme yöntemini seçiniz</p>
              </vs-row>
            </vs-col>
          </vs-row>
        </div>
        <div class="other-pay-popup-scroll">
          <div class="other-pay-grid">
            <vs-button
              v-for="paymentMethod in otherPaymentMethods"
              :key="paymentMethod.id"
              @click="selectOtherPaymentMethod(paymentMethod)"
              color="transparent"
              :class="{
                'bg-success text-white': paymentMethod.selected,
                'bg-secondary': !paymentMethod.selected
              }"
              class="text-primary sale-box-shadow half-friendly-border bold other-pay-method-btn"
              size="small"
            >
              {{ paymentMethod.name }}
            </vs-button>
          </div>
        </div>
        <div class="other-pay-popup-footer">
          <vs-button
            type="gradient"
            color="primary"
            class="other-pay-footer-btn other-pay-footer-back"
            icon-pack="feather"
            icon="icon-arrow-left"
            @click="closeOtherPaymentMethods"
          >
            Geri Dön
          </vs-button>
          <vs-button
            type="gradient"
            color="success"
            class="other-pay-footer-btn other-pay-footer-confirm"
            icon-pack="feather"
            icon="icon-check"
            icon-after
            @click="confirmOtherPaymentSelection"
          >
            Onayla
          </vs-button>
        </div>
      </div>
    </vs-popup>
    <button
      v-for="paymentMethod in standartPaymentMethods"
      :key="paymentMethod.id"
      v-show="dontCloseCalc == false || (dontCloseCalc == true && paymentMethod.id != 4)"
      :disabled="totalPrice == 0"
      @click="setSelectedPaymentMethod(paymentMethod)"
      type="button"
      class="pay-method-btn"
      :class="{ 'btn-selected': isSelected(paymentMethod), 'btn-default': !isSelected(paymentMethod) }"
      :style="isSelected(paymentMethod) 
        ? 'background: linear-gradient(135deg, #2d8a54 0%, #1e6b3f 100%) !important; color: white !important; font-size: 1rem !important; opacity: 1 !important; visibility: visible !important; min-width: 120px !important; min-height: 45px !important; margin: 0 5px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; position: relative !important; z-index: 9999 !important; border: 2px solid #2d8a54 !important; border-radius: 12px !important;' 
        : 'background: linear-gradient(135deg, #5a3432 0%, #422624 50%, #2c1816 100%) !important; color: white !important; font-size: 1rem !important; opacity: 1 !important; visibility: visible !important; min-width: 120px !important; min-height: 45px !important; margin: 0 5px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; position: relative !important; z-index: 9999 !important; border: 2px solid #5a3432 !important; border-radius: 12px !important;'"
    >
      <span style="color: white !important; font-size: 1rem !important; font-weight: bold !important; opacity: 1 !important; visibility: visible !important; z-index: 10000 !important; display: block !important; margin: 0 !important; padding: 0 !important;">{{ paymentMethod.name || paymentMethod.Name }}</span>
    </button>
    <button
      v-show="otherPaymentMethods.length > 0"
      :disabled="totalPrice == 0"
      @click="showOtherPaymentMethods = true"
      type="button"
      class="pay-method-btn pay-method-btn--other"
      style="background: linear-gradient(135deg, #5a3432 0%, #422624 50%, #2c1816 100%) !important; color: white !important; font-size: 1rem !important; opacity: 1 !important; visibility: visible !important; min-width: 120px !important; min-height: 45px !important; margin: 0 5px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; position: relative !important; z-index: 9999 !important; border: 2px solid #5a3432 !important; border-radius: 12px !important;"
    >
      <span style="color: white !important; font-size: 1rem !important; font-weight: bold !important; opacity: 1 !important; visibility: visible !important; z-index: 10000 !important; display: block !important; margin: 0 !important; padding: 0 !important;">Diğer</span>
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      totalPrice: {
        type: Number,
        required: false
      },
      dontCloseCalc: {
        type: Boolean,
        required: false
      },
      currentTime: {
        type: String,
        required: true
      },
      currentDate: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        showOtherPaymentMethods: false,
      };
    },
    computed: {
      activePersonal: function () {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      paymentMethods: {
        get() {
          return this.$store.getters["selfservice/getPaymentMethods"];
        },
      },
      standartPaymentMethods() {
        const rawMethods = this.$store.getters["selfservice/getPaymentMethods"];
        const list = (rawMethods || []).filter(
          (x) => {
            if (!x) return false;
            if (x.type === "Single") return false;
            const name = (x.name || x.Name || "").toLowerCase();
            return name !== "diğer" && name !== "diger";
          }
        );
        const sorted = this.sortStandardPaymentMethods(list);
        return sorted;
      },
      otherPaymentMethods() {
        const list = this.$store.getters["selfservice/getPaymentMethods"].filter(
          (x) => x.originPaymentMethodId == this.$othersPaymentId && x.id !== 25
        );
        return this.sortPaymentMethodsByName(list);
      },
      selectedPaymentMethod: {
        get() {
          return this.$store.getters["selfservice/getSelectedPaymentMethod"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);
        }
      }
    },
    watch: {
      showOtherPaymentMethods(val, oldVal) {
        if (oldVal == true && val == false && this.dontCloseCalc == true) {
          this.$emit("dontClose");
        }
      }
    },
    methods: {
      sortPaymentMethodsByName(methods) {
        if (!methods || !methods.length) return [];
        return [...methods].sort((a, b) =>
          String(a.name || "").localeCompare(String(b.name || ""), "tr", {
            sensitivity: "base",
            numeric: true,
          })
        );
      },
      /** Ödeme ekranı: Nakit | Kredi Kartı | Diğer | İndirim — diğer tipler sonda, ada göre */
      normalizePayLabel(s) {
        return String(s || "")
          .trim()
          .toLocaleLowerCase("tr-TR")
          .replace(/\s+/g, " ");
      },
      standardPaymentOrderRank(m) {
        const n = this.normalizePayLabel(m.name);
        if (n === "nakit" || n.startsWith("nakit ")) return 0;
        if (n.includes("kredi") && n.includes("kart")) return 1;
        if (n === "diğer" || n === "diger") return 2;
        if (n.includes("indirim")) return 3;
        return 100;
      },
      sortStandardPaymentMethods(methods) {
        if (!methods || !methods.length) return [];
        return [...methods].sort((a, b) => {
          const ra = this.standardPaymentOrderRank(a);
          const rb = this.standardPaymentOrderRank(b);
          if (ra !== rb) return ra - rb;
          return String(a.name || "").localeCompare(String(b.name || ""), "tr", {
            sensitivity: "base",
            numeric: true,
          });
        });
      },
      isSelected(method){
        if(method.selected == true || this.paymentMethods.filter(x=> x.originPaymentMethodId == method.id).some(y=> y.selected == true)) return true;
        else return false;
      },
      setSelection(paymentMethod) {
        this.selectedPaymentMethod = paymentMethod;
      },
      /** Sadece seçim (popup açık kalır — Onayla ile kapanır) */
      selectOtherPaymentMethod(paymentMethod) {
        this.setSelection(paymentMethod);
      },
      closeOtherPaymentMethods() {
        this.showOtherPaymentMethods = false;
      },
      confirmOtherPaymentSelection() {
        const sel = this.selectedPaymentMethod;
        if (!sel || !this.otherPaymentMethods.some((m) => m.id === sel.id)) {
          if (this.$vs && this.$vs.notify) {
            this.$vs.notify({
              color: "warning",
              title: "Seçim gerekli",
              text: "Lütfen listeden bir ödeme yöntemi seçin veya Geri Dön ile çıkın.",
            });
          }
          return;
        }
        this.showOtherPaymentMethods = false;
      },

      setSelectedPaymentMethod(method) {
        if (this.paymentMethods.some(x => x.originPaymentMethodId == method.id)) this.showOtherPaymentMethods = true;
        else this.setSelection(method);
      }
    },

  };

</script>

<style>
  .select-payment-type-buttons {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 0.75rem !important;
    width: 100% !important;
    margin: 0.35rem 0 !important;
    position: relative !important;
    z-index: 10 !important;
  }

  .select-payment-type-buttons button.pay-method-btn,
  .select-payment-type-buttons .pay-method-btn {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    transform: none !important;
    float: none !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0.65rem 1.4rem !important;
    font-size: 1rem !important;
    font-weight: 700 !important;
    line-height: 1.2 !important;
    letter-spacing: 0.02em !important;
    border-radius: 12px !important;
    border: 1px solid rgba(62, 38, 36, 0.14) !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
    box-shadow: 0 4px 14px rgba(62, 38, 36, 0.18) !important;
    min-width: 7.5rem !important;
    min-height: 2.85rem !important;
    box-sizing: border-box !important;
    text-indent: 0 !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  .select-payment-type-buttons button.pay-method-btn.btn-selected,
  .select-payment-type-buttons .pay-method-btn.btn-selected {
    background: linear-gradient(135deg, #2d8a54 0%, #1e6b3f 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 0 0 2px rgba(45, 138, 84, 0.5), 0 8px 20px rgba(45, 138, 84, 0.25) !important;
  }

  .select-payment-type-buttons button.pay-method-btn.btn-default,
  .select-payment-type-buttons .pay-method-btn.btn-default {
    background: linear-gradient(135deg, #5a3432 0%, #422624 50%, #2c1816 100%) !important;
    color: #ffffff !important;
  }

  .select-payment-type-buttons button.pay-method-btn:disabled,
  .select-payment-type-buttons .pay-method-btn:disabled {
    opacity: 0.55 !important;
    cursor: not-allowed !important;
  }

  .margin10 {
    margin-bottom: 10px !important;
  }

  #otherPayTypesPage .vs-popup .vs-popup--header {
    display: none;
  }

  #otherPayTypesPage .vs-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
    max-height: min(92vh, 720px) !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
    box-sizing: border-box;
  }

  #otherPayTypesPage .vs-popup {
    border-radius: 2rem !important;
    max-height: min(94vh, 740px) !important;
  }

  .other-pay-popup-inner {
    display: flex;
    flex-direction: column;
    max-height: min(90vh, 700px);
    min-height: 0;
    overflow: hidden;
  }

  .other-pay-popup-header {
    flex-shrink: 0;
  }

  .other-pay-title-btn.payment-label {
    font-size: 0.95rem !important;
    padding-top: 0.45rem !important;
    padding-bottom: 0.45rem !important;
  }

  .other-pay-title-btn.payment-label i {
    font-size: 1.35rem !important;
    margin-right: 0.65rem !important;
  }

  .other-pay-info-row.info-row {
    padding: 0.45rem 0.65rem !important;
    font-size: 0.78rem !important;
  }

  .other-pay-hero-row {
    padding: 0.35rem 0.5rem 0.25rem !important;
  }

  .other-pay-hero-img {
    width: 18% !important;
    max-width: 72px;
    min-width: 48px;
  }

  .other-pay-hint {
    font-size: 0.8rem !important;
    font-weight: 500;
    margin: 0.25rem 0 0;
    text-align: center;
    padding: 0 0.5rem;
  }

  .other-pay-popup-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding: 0.4rem 0.55rem 0.55rem;
  }

  .other-pay-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: flex-start;
    gap: 0.55rem 0.65rem;
  }

  .other-pay-method-btn.vs-button {
    min-height: 2.85rem !important;
    height: auto !important;
    padding: 0.5rem 0.95rem !important;
    margin: 0 !important;
    border-radius: 12px !important;
    max-width: 100%;
  }

  .other-pay-method-btn .vs-button--text {
    font-size: 0.98rem !important;
    line-height: 1.3 !important;
    white-space: normal !important;
    text-align: center;
    word-break: break-word;
    padding: 0.1rem 0.15rem !important;
    font-weight: 600;
  }

  .other-pay-popup-footer {
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0.5rem;
    padding: 0.55rem 0.65rem 0.65rem;
    border-top: 1px solid rgba(74, 44, 42, 0.1);
    background: linear-gradient(180deg, #fdfcfa 0%, #f2ece9 100%);
    box-sizing: border-box;
  }

  .other-pay-footer-btn {
    flex: 1 1 0%;
    min-width: 0;
    font-weight: 700 !important;
    font-size: 0.82rem !important;
    min-height: 2.5rem !important;
    border-radius: 12px !important;
  }

  .other-pay-footer-confirm .vs-button--text {
    font-size: 0.82rem !important;
  }

  /* Geri Dön: border tipi çok soluk kalıyordu — dolu kahve ton, beyaz yazı/ikon */
  #otherPayTypesPage .other-pay-footer-back.vs-button {
    background: linear-gradient(180deg, #9a4a3e 0%, #6d2f28 48%, #5a2822 100%) !important;
    color: #fff !important;
    border: 1px solid rgba(40, 18, 14, 0.35) !important;
    box-shadow: 0 4px 14px rgba(90, 40, 34, 0.45) !important;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  }

  #otherPayTypesPage .other-pay-footer-back .vs-button-background,
  #otherPayTypesPage .other-pay-footer-back .vs-button--background {
    opacity: 0 !important;
  }

  #otherPayTypesPage .other-pay-footer-back .vs-button--text,
  #otherPayTypesPage .other-pay-footer-back span:not(.vs-button-background) {
    color: #fff !important;
    font-size: 0.84rem !important;
    font-weight: 700 !important;
    letter-spacing: 0.02em;
  }

  #otherPayTypesPage .other-pay-footer-back .vs-icon,
  #otherPayTypesPage .other-pay-footer-back i {
    color: #fff !important;
    font-size: 1rem !important;
  }

  /* Masaüstü: ödeme yöntemi butonları daha büyük, aralıklar geniş */
  @media screen and (min-width: 1024px) {
    #otherPayTypesPage .other-pay-popup-scroll {
      padding: 0.6rem 1rem 0.85rem;
    }

    #otherPayTypesPage .other-pay-grid {
      gap: 0.9rem 1.1rem;
    }

    #otherPayTypesPage .other-pay-method-btn.vs-button {
      min-height: 3.35rem !important;
      padding: 0.62rem 1.2rem !important;
      border-radius: 14px !important;
    }

    #otherPayTypesPage .other-pay-method-btn .vs-button--text {
      font-size: 1.06rem !important;
      line-height: 1.38 !important;
      padding: 0.12rem 0.2rem !important;
    }
  }
</style>
